__turbopack_context__.v({
  "bentoCard": "vB_Caa_bentoCard",
  "corporateHead": "vB_Caa_corporateHead",
  "light": "vB_Caa_light",
  "m1": "vB_Caa_m1",
  "popularTag": "vB_Caa_popularTag",
  "ring": "vB_Caa_ring",
  "root": "vB_Caa_root",
});
